export const initialState = {
  fetched: false,
  user: null,
  sign_in_error: '',
  uiState: {
    isSimulationAnimating: true,
  },
};
export default function reducer(state = initialState, action) {
  let uiState = {};
  switch (action.type) {
    case 'USER_FETCHED':
      return Object.assign({}, state, { fetched: true, user: action.payload, sign_in_error: '' });
    case 'CLAIM_GUEST_SUCCESS':
      return Object.assign({}, state, { fetched: true, user: action.payload, sign_in_error: '' });
    case 'CLAIM_GUEST_FAILURE':
      return Object.assign({}, state, { fetched: true, user: null, sign_in_error: action.payload.error });
    case 'SIGN_IN_FAILURE':
      return Object.assign({}, state, { fetched: true, user: null, sign_in_error: action.payload.error });
    case 'ANIMATE_SIMULATION_ONBOARDING':
      uiState = Object.assign({}, state.uiState, { isSimulationAnimating: action.payload });
      return Object.assign({}, state, { uiState });
    default:
      return state;
  }
}
